import React, { forwardRef } from 'react';

import { Container, Label } from './styles';

const Input = forwardRef(({ name, value, type, label, status = false, change, maxLength, disabled = false }, ref) => {
  return (
    <Container status={status.status}>
      <Label status={status.status}>{label}</Label>

      <input
        ref={ref}
        name={name}
        type={type}
        value={value}
        onChange={(e) => change(e.target.value)}
        maxLength={maxLength}
        disabled={disabled}
      />

      <div className="feedback">{status.feedback}</div>
    </Container>
  );
});

export default Input;